export default __webpack_public_path__ + "static/media/ca.c3131740.jpg";